import { useState } from "react";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
const PasswordReset = () => {
  const [loading, setLoading] = useState(false); // New state variable for loading state
  const [verifyemail, setVerifyEmail]=useState('')
const handleReset=async (e)=>{
e.preventDefault();
try {
  setLoading(true);
const response = await fetch('https://campus-closet-server.vercel.app/api/resetPassword', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email: verifyemail })
  });
  if (response.ok) {
    const data= await response.json();
    console.log(data);
    const resetToken=data.resetToken
    if (resetToken) {
      toast.success('Check Your Email for password reset Link!', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 5000
      });

      setLoading(false);
        const response2 = await fetch('https://mailing-server-six.vercel.app/api/sendresetPassword', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email: data.email, resetToken, name:data.username })
        });
        if (response2.ok) {
            console.log("Email sent successfully");
            setVerifyEmail('')
        }
    }
    // Add any logic you want to show a success message or redirect to another page
  } else if(response.status === 400) {
      toast.error('Email address not registered', {
        position: toast.POSITION.TOP_CENTER,
        autoClose: 2000
      });
    setLoading(false);
  }
} catch (error) {
    console.error("Error occurred while sending password reset email", error);
    toast.error('Failed to reset your password, try again', {
      position: toast.POSITION.TOP_CENTER,
      autoClose: 2000
    });
    // Add any logic you want to show an error message
  } finally {
    setLoading(false); // Set loading state back to false after the API call is complete
  }
}

const handleEmailChange = (e) => {
    setVerifyEmail(e.target.value);
  };
  return (
    <section className="bg-gray-50">
      <div className="auth-forms flex flex-col items-center justify-center px-6 py-8 mx-auto lg:py-0">
        <div className="form w-full bg-white rounded-lg shadow dark:border md:mt-0 sm:max-w-md xl:p-0">
          <div className="p-6 space-y-2 xl:space-y-3 sm:p-8">
            <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl">
              Reset your password
            </h1>
            <p className="text-gray-600 mb-4">
              Enter your user account's verified email address and we will send
              you a password reset link.
            </p>
            <form onSubmit={handleReset}>
              <input
                type="email"
                placeholder="Enter your email address"
                required
                value={verifyemail}
                onChange={handleEmailChange}
                className="bg-gray-50 border border-gray-300 text-gray-900 sm:text-sm mb-10 rounded-lg focus:ring-primary-600 focus:border-primary-600 block w-full p-2"
              
              />
              <button
                type="submit"
                className={`w-full text-gray-900 bg-blue-400 hover:bg-blue-500 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center ${
                  loading ? "opacity-50 cursor-not-allowed" : ""
                }`}
              >
                {/* Change button text to "Loading..." when loading is true */}
                {loading ? "Loading..." : "send password reset email"}
              </button>
            </form>
          </div>
        </div>
      </div>
      <ToastContainer />
    </section>
  );
};

export default PasswordReset;
